'use client'

import { Fieldset as FieldsetPrimitive } from '@base-ui/react/fieldset'
import { cn } from '../lib/utils'

function Fieldset({ className, ...props }: FieldsetPrimitive.Root.Props) {
  return (
    <FieldsetPrimitive.Root
      className={cn('flex w-full max-w-64 flex-col gap-6', className)}
      data-slot="fieldset"
      {...props}
    />
  )
}
function FieldsetLegend({
  className,
  ...props
}: FieldsetPrimitive.Legend.Props) {
  return (
    <FieldsetPrimitive.Legend
      className={cn('text-on-surface -mb-[16px] font-bold', className)}
      data-slot="fieldset-legend"
      {...props}
    />
  )
}

export { Fieldset, FieldsetLegend, FieldsetPrimitive }
